import { render, staticRenderFns } from "./educationCompletePop.vue?vue&type=template&id=9ae569cc"
import script from "./educationCompletePop.vue?vue&type=script&lang=js"
export * from "./educationCompletePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ae569cc')) {
      api.createRecord('9ae569cc', component.options)
    } else {
      api.reload('9ae569cc', component.options)
    }
    module.hot.accept("./educationCompletePop.vue?vue&type=template&id=9ae569cc", function () {
      api.rerender('9ae569cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationCompletePop.vue"
export default component.exports